export default __webpack_public_path__ + "static/media/image-launch-vehicle-portrait.0c758955.jpg";